/* eslint-disable */
import {
  fully_invested_actions,
  defaultWhaleTraderCriteria,
  marketTiming
} from '@/data/whale_trader_constants'
import cloneDeep from 'lodash/cloneDeep'

export default {

  SET_GROUPS (state, groups) {
    function compare( a, b ) {
      if ( a.name < b.name ){
        return -1;
      }
      if ( a.name > b.name ){
        return 1;
      }
      return 0;
    }
    groups.forEach(bt => {
      bt.filers.sort(compare)
    })
    state.groups = groups
  },

  SET_EMAIL_ALERTS (state, alerts) {
    state.emailAlerts = alerts
  },

  SET_BACKTESTS (state, backtests) {
    function extractMonthlyPerformance (bt, data) {
      bt.monthly_performance = []
      let whale = data[0]
      let sp = data[1]

      for (let k = 0; k < whale.values.length; k++) {
        let d = whale.values[k]
        let e = sp.values[k]
        bt.monthly_performance.push({
          month: d.x,
          whale: d.y,
          sp: e.y,
          diff: d.y - e.y
        })
      }
    }

    backtests.forEach(bt => {
      extractMonthlyPerformance(bt, JSON.parse(bt.chart_data))
      bt.last_portfolio = JSON.parse(bt.last_portfolio)
      bt.criteria = JSON.parse(bt.criteria_json)
    })

    state.trackedBacktests = backtests
  },

  SET_USER (state, user) {
    if (!user) return

    state.user = user

    const today = new Date()
    const yesterday = today.setDate(today.getDate() - 1)

    if (user.subscription_limit && (user.subscription_limit.allowed_team_members > 0 || user.primary_account)) {
      state.isTeamMember = true
    }

    if (user.user_subscription) {
      let date = new Date(user.user_subscription.subscription_end_date)
      state.isSubscriber = date >= yesterday
    }

    if (state.isSubscriber) {
      state.limit = 50
      if (user.user_subscription.subscription_type_id === 2) {
        state.isProSubscriber = true
      } else if (user.user_subscription.subscription_type_id === 3) {
        state.isEnterpriseSubscriber = true
        state.limit = 9999
      }
      if (user.subscription_limit) {
        state.limit = user.subscription_limit.report_filer_limit
      }
    }

    if (user.primary_account) {
      let date = new Date(user.primary_account.user_subscription.subscription_end_date)

      state.isSubscriber = date >= yesterday

      if (state.isSubscriber) {
        if (user.primary_account.subscription_limit) {
          state.limit = user.primary_account.subscription_limit.report_filer_limit
        }
        if (user.primary_account.user_subscription.subscription_type_id === 2) {
          state.isProSubscriber = true
        } else if (user.primary_account.user_subscription.subscription_type_id === 3) {
          state.isEnterpriseSubscriber = true
          state.limit = 9999
        }
      } else {
        state.limit = 5
        state.isEnterpriseSubscriber = false
        state.isProSubscriber = false
      }
    }
  },

  SET_INSIDER_ALERTS (state, insiderAlerts) {
    insiderAlerts.forEach(alert => {
      let criteria = JSON.parse(alert.criteria_body)
      let cluster = criteria.alert_criteria.entry_cluster_buy_criteria

      let transactionType = cluster.transaction_type === 1
        ? 'All Buy Transactions'
        : 'Open Market Purchases'

      let dateRange =
        cluster.date_range === 0 ? 'Past Day'
        : cluster.date_range === 1 ? 'Past 3 Days'
        : cluster.date_range === 2 ? 'Past 7 Days'
        : cluster.date_range === 3 ? 'Past Month'
        : cluster.date_range === 4 ? 'Past 3 Months'
        : 'Past 2 Weeks'

      let ownerTypes = (() => {
        if (!cluster.owner_types.length || cluster.owner_types.length === 5) {
          return ['All']
        } else {
          return cluster.owner_types
            .map(type => (
              type === 1 ? '>10% Owner'
              : type === 2 ? 'Director'
              : type === 3 ? 'Officer'
              : type === 4 ? 'C-Level Officer'
              : 'Other Owner'
            ))
        }
      })()

      alert.strategy = {
        transactionType,
        dateRange,
        ownerTypes
      }
    })

    state.insiderAlerts = insiderAlerts
  },

  SET_TRADING_MODELS (state, params) {
    var tradingModels=params.tradingModels;
    var rootState=params.rootState;
    /*var default_criteria=Object.assign({}, defaultWhaleTraderCriteria);
    tradingModels.forEach(model => {
      var criteria=null;
      if ((typeof model.criteria === 'string') || (model.criteria instanceof String)){
        criteria=JSON.parse(model.criteria);
        var defaultwi=default_criteria.signals.whaleindex_signal;
        var wi=criteria.signals.whaleindex_signal;
        if (!wi){
          criteria.signals.whaleindex_signal=cloneDeep(defaultwi);
        }
        else {
          for (var i=0;i<defaultwi.whale_indices.length;i++){
            var indice=defaultwi.whale_indices[i];
            var found=wi.whale_indices.find( ({ whale_index_id }) => whale_index_id === indice.whale_index_id)
            if (!found){
              wi.whale_indices.push( cloneDeep(indice))
            }
          }
        }
        if (typeof criteria.signals.trend_signal.moving_average_rules == 'undefined') {
          criteria.signals.trend_signal.moving_average_rules=[];
        }
        for (var i=0;i<criteria.signals.trend_signal.breakout_rules.length;i++){
          var rule=criteria.signals.trend_signal.breakout_rules[i]
          if ("enabled" in rule){

          }else{
            rule.enabled=true;
          }
        }
        for (var i=0;i<criteria.signals.trend_signal.stocks_vs_sp.length;i++){
          var rule=criteria.signals.trend_signal.stocks_vs_sp[i]
          if ("enabled" in rule){

          }else{
            rule.enabled=true;
          }
        }
        if (!criteria.market_timing_rules){
          criteria.market_timing_rules=[];
        }
        if (!criteria.market_timing){
            var mt=cloneDeep(marketTiming);
            criteria.market_timing=mt;
        }
        else{
          if (typeof criteria.market_timing.moving_average.enabled == 'undefined') {
              criteria.market_timing.moving_average.enabled=true;
          }
          if (!criteria.market_timing.index_performance){
            criteria.market_timing.index_performance=cloneDeep(marketTiming.index_performance);
          }
          for (var i=0;i<marketTiming.recession_indicators.length;i++){
            var rule=marketTiming.recession_indicators[i]
            var found=criteria.market_timing.recession_indicators.find( element => element.macro_data_type_id === rule.macro_data_type_id );
            if (!found)
              criteria.market_timing.recession_indicators.push(cloneDeep(rule));
          }
          if (!criteria.market_timing.resume_indicators){
            criteria.market_timing.resume_indicators=cloneDeep(marketTiming.resume_indicators);
          }
          else{
            for (var i=0;i<marketTiming.resume_indicators.length;i++){
              var rule=marketTiming.resume_indicators[i]
              var found=criteria.market_timing.resume_indicators.find( element => element.id === rule.id );
              if (!found)
                criteria.market_timing.resume_indicators.push(cloneDeep(rule));
            }
          }
        }

        var fia=cloneDeep(fully_invested_actions);
        if (criteria.entry_rules.long.fully_invested_actions){
          for (var i=0;i<fia.length;i++){
            var rule=fia[i]
            var found=criteria.entry_rules.long.fully_invested_actions.find( ({ value }) => value === rule.value );
            if (!found)
              criteria.entry_rules.long.fully_invested_actions.push(rule);
            else if ((rule.value==10)){
              if (found.stock_up_enabled === undefined){
                found.stock_up_enabled=false
                found.stock_up_at_least=1;
              }
            }
            else if ((rule.value==11)){
              if (found.stock_down_enabled === undefined){
                found.stock_down_enabled=false
                found.stock_down_at_least=1;
              }
            }
          }
        }
        if (!criteria.entry_rules.long.fully_invested_actions ||criteria.entry_rules.long.fully_invested_actions.length==0){
          criteria.entry_rules.long.fully_invested_actions=cloneDeep(fully_invested_actions)
          if (criteria.entry_rules.long.fully_invested_action_id>0){
            for (var i=0;i<criteria.entry_rules.long.fully_invested_actions.length;i++){
              var e=criteria.entry_rules.long.fully_invested_actions[i];
              if (e.value==criteria.entry_rules.long.fully_invested_action_id){
                e.enabled=true;
                e.percentage=criteria.entry_rules.long.sell_underperforming_up_percentage;
                criteria.entry_rules.long.fully_invested_action_id=null;
                break;
              }
            }
          }
          criteria.entry_rules.short.fully_invested_actions=cloneDeep(fully_invested_actions)
          if (criteria.entry_rules.short.fully_invested_action_id>0){
            for (var i=0;i<criteria.entry_rules.short.fully_invested_actions.length;i++){
              var e=criteria.entry_rules.short.fully_invested_actions[i];
              if (e.value==criteria.entry_rules.short.fully_invested_action_id){
                e.enabled=true;
                criteria.entry_rules.short.fully_invested_action_id=null;
                e.percentage=criteria.entry_rules.short.sell_underperforming_up_percentage;
                break;
              }
            }
          }
        }
        var fp=criteria.signals.f13_signal.filer_performance;
        if (typeof fp.market_cap_range_min == 'undefined') {
          fp.use_market_cap_range=false
              fp.market_cap_range_min=40
              fp.market_cap_range_max=100
              fp.market_cap_range=[6,10]
        }
        if (!fp.sc){
          fp.sc={
              identifier: 'sector_concentration',
              type: 'dynamic_number_range',
              title: '13F Sector Concentration',
              suffix: '%',
              prefix:'',
              items: []
            }
          }
          if (!fp.sc.items || fp.sc.items.length==0){
            for (var i=0;i<rootState.ww.sectors.length;i++){
              var s=cloneDeep(rootState.ww.sectors[i])
              s.selected=false;
              s.from=null;
              s.to=null;
              fp.sc.items.push(s);
            }

          }
        model.criteria=criteria;
      }

    })*/

    state.tradingModels= tradingModels;
  }


}
